/**
 * Action Types
 */

export const Types = {
    SELECT_PRODUTO: 'produto/SELECT_PRODUTO',
    CLEAR_PRODUTOS_SELECIONADOS: 'produto/CLEAR_PRODUTOS_SELECIONADOS'
};

/**
 * Reducer
 */

const INITIAL_STATE = [];

export default function produtoSelecionado(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Types.SELECT_PRODUTO:
            const produto = action.payload;
            let hasProduto = state.includes(produto);

            if (!hasProduto) {
                return [...state, action.payload];
            } else {
                const newState = state.filter(
                    (item) => item.idProduto !== produto.idProduto
                );

                return newState;
            }

        case Types.CLEAR_PRODUTOS_SELECIONADOS:
            return INITIAL_STATE;

        default:
            return state;
    }
}

/**
 * Action Creators
 */

export const Creators = {
    selectProduto: (payload) => ({
        type: Types.SELECT_PRODUTO,
        payload
    }),
    clearProdutoSelecionado: () => ({
        type: Types.CLEAR_PRODUTOS_SELECIONADOS
    })
};
